<template>
  <PublicPopup
    ref="EncontreNosPopupRef"
    background="var(--download-popup-bg)"
    @close="emit('close')"
  >
    <template #header>
      <div class="popup-header-container chxy-row-c-c">
        <img class="icon" :src="getImageUrlWithCDN_TEST('/download/icon_city_search.png')" />
        <p class="title">{{ $t('DownloadPopup-EncontreNosPopup.title') }}</p>
      </div>
    </template>
    <template #content>
      <div class="download-popup">
        <div class="card kind-tips-container">
          <span>
            <van-icon name="checked" class="checked-icon" />
            {{ $t('DownloadPopup-EncontreNosPopup.tip') }}
          </span>
        </div>

        <div class="card web-link-container">
          <div class="web-link-header chxy-row-bt">
            <div class="left-container chxy-row-c-c">
              <img class="icon" :src="getImageUrlWithCDN_TEST('/download/icon_web_link.png')" />
              <span class="value">{{ $t('DownloadPopup-EncontreNosPopup.saveUrl') }}</span>
            </div>
            <div class="right-container chxy-row-c-c" @click="handleCopyAll('webLink')">
              <SvgIcon name="public-copy_theme" fill="var(--public-copy-theme)" :size="13.5" />
              <span class="value">{{ $t('DownloadPopup-EncontreNosPopup.copyAll') }}</span>
            </div>
          </div>
          <div class="wen-link-content">
            <p>{{ $t('DownloadPopup-EncontreNosPopup.visitOfficial') }}</p>
          </div>
          <div v-for="item in webLinkList" :key="item.label" class="web-link-item chxy-row-ac">
            <span class="label">{{ $t('DownloadPopup-EncontreNosPopup.urlInicial') }}</span>
            <a class="link" :href="item.link" target="_blank">{{ item.value }}</a>
            <SvgIcon
              name="public-copy_theme"
              fill="var(--public-copy-theme)"
              :size="11.5"
              class="icon"
              @click="handleCopy(item.link)"
            />
          </div>
          <div class="web-link-footer">
            <button class="buttons link">
              {{ $t('DownloadPopup-EncontreNosPopup.savePhoto') }}
            </button>
            <button class="buttons">{{ $t('DownloadPopup-EncontreNosPopup.saveToNotes') }}</button>
          </div>
        </div>

        <div class="card web-link-container">
          <div class="web-link-header chxy-row-bt">
            <div class="left-container chxy-row-c-c">
              <img class="icon" :src="getImageUrlWithCDN_TEST('/download/icon_e-mail.png')" />
              <span class="value">{{ $t('DownloadPopup-EncontreNosPopup.saveEmail') }}</span>
            </div>
            <div class="right-container chxy-row-c-c" @click="handleCopyAll('e-mail')">
              <SvgIcon name="public-copy_theme" fill="var(--public-copy-theme)" :size="13.5" />
              <span class="value">{{ $t('DownloadPopup-EncontreNosPopup.copyAll') }}</span>
            </div>
          </div>
          <div class="wen-link-content">
            <p>{{ $t('DownloadPopup-EncontreNosPopup.saveEmailDesc') }}</p>
          </div>
          <div v-for="item in eMailList" :key="item.label" class="web-link-item chxy-row-ac">
            <span class="label">{{ $t('DownloadPopup-EncontreNosPopup.emailOfficial') }}</span>
            <span class="link">{{ item.value }}grupo@gmail.com</span>
            <SvgIcon
              name="public-copy_theme"
              fill="var(--public-copy-theme)"
              :size="11.5"
              class="icon"
              @click="handleCopy(item.link)"
            />
            <SvgIcon
              name="public-link_theme"
              fill="var(--public-copy-theme)"
              :size="11.5"
              class="icon"
            />
          </div>
          <div class="web-link-footer">
            <button class="buttons link">
              {{ $t('DownloadPopup-EncontreNosPopup.savePhoto') }}
            </button>
            <button class="buttons">{{ $t('DownloadPopup-EncontreNosPopup.saveToNotes') }}</button>
          </div>
        </div>

        <div class="card web-link-container">
          <div class="web-link-header chxy-row-bt">
            <div class="left-container chxy-row-c-c">
              <SvgIcon
                name="public-download_icon_theme"
                fill="var(--public-copy-theme)"
                :size="22"
                class="icon"
              />
              <span class="value">{{ $t('DownloadPopup-EncontreNosPopup.downloadApp') }}</span>
            </div>
          </div>
          <div class="wen-link-content">
            <p>{{ $t('DownloadPopup-EncontreNosPopup.downloadAppDesc') }}</p>
          </div>
          <div style="margin-top: 30px">
            <InstallButtons
              ref="InstallButtonsRef"
              @quick="handleQuick"
              @install="handleInstall"
              @tutorial="handleDownloadGuidePopupOpen"
            />
          </div>
        </div>
      </div>
    </template>
    <template #other>
      <CheckboxPublic v-if="checkboxPublic" type="encontre-nos" />
    </template>
  </PublicPopup>

  <DownloadGuidePopup2 ref="DownloadGuidePopupRef" />
</template>

<script setup>
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const GrupoSeries = computed(() => {
  const str = JSON.parse(localStorage.getItem('localConfig')).gameGroupType || ''
  return str.toLowerCase()
})
const GameWebLink = computed(() => {
  return JSON.parse(localStorage.getItem('localConfig')).gameWebLink || ''
})

/**
 * 下载引导弹窗
 */
const DownloadGuidePopupRef = ref(null)
const handleDownloadGuidePopupOpen = () => {
  nextTick(() => {
    DownloadGuidePopupRef.value.open()
  })
}

const props = defineProps({
  type: {
    type: String,
    default: 'images',
  },
  checkboxPublic: {
    type: Boolean,
    default: false,
  },
})

const EncontreNosPopupChecked = ref(window.localStorage.EncontreNosPopupChecked || 'null')

const EncontreNosPopupRef = ref(null)
const InstallButtonsRef = ref(null)

const webLinkList = ref([
  {
    content: `${t('DownloadPopup-EncontreNosPopup.urlInicial')} ${GameWebLink.value}`,
    value: GameWebLink.value,
    link: `https://${GameWebLink.value}`,
  },
])

const eMailList = ref([
  {
    content: `${t('DownloadPopup-EncontreNosPopup.emailOfficial')} ${GrupoSeries.value}`,
    value: GrupoSeries.value,
    link: `https://${GrupoSeries.value}`,
  },
])

const handleCopy = async (link) => {
  try {
    await navigator.clipboard.writeText(link)
    showToast(t('DownloadPopup-EncontreNosPopup.copiedSuccess'))
  } catch (error) {
    console.log('error ----- ', error)
  }
}

const handleCopyAll = async (type) => {
  let content = ''

  if (type === 'webLink') {
    webLinkList.value.forEach((item, index) => {
      content += `${t('DownloadPopup-EncontreNosPopup.urlInicial')}${++index}:${item.content}\n`
    })
  } else if (type === 'e-mail') {
    eMailList.value.forEach((item, index) => {
      content += `${t('DownloadPopup-EncontreNosPopup.emailOfficial')}${++index}:${item.content}\n`
    })
  }

  await nextTick(() => {
    try {
      navigator.clipboard.writeText(content)
      showToast(t('DownloadPopup-EncontreNosPopup.copiedSuccess'))
    } catch (error) {
      console.log('error ----- ', error)
    }
  })
}

// 下载pwa的前置弹窗
const open = () => {
  if (props.checkboxPublic) {
    if (EncontreNosPopupChecked.value === 'checked') return false
  }

  nextTick(() => {
    EncontreNosPopupRef.value.open()

    const installPrompt = window.deferredPrompt
    if (installPrompt) {
      nextTick(() => {
        InstallButtonsRef.value.init(installPrompt)
      })
    }
  })
}

const emit = defineEmits(['close'])

defineExpose({ open })
</script>

<style scoped lang="scss">
.popup-header-container {
  gap: 8px;
  width: 100%;
  height: 24px;
  font-size: 16px;
  color: var(--popup-primary-title);
  line-height: 24px;

  .icon {
    width: 20px;
    height: 20px;
  }
}
.download-popup {
  margin-top: 5px;
  width: 320px;

  .card {
    background-color: var(--download-popup-card-bg);
    box-shadow: 0 1.5px 3.5px 0 #0000001f;
    border-radius: 8px;
    padding: 10px;
    margin-top: 10px;
  }

  .kind-tips-container {
    font-size: 12px;
    font-weight: 700;
    color: var(--download-popup-value);

    .checked-icon {
      font-size: 14px;
      color: var(--download-popup-check-icon);
    }
  }

  .web-link-container {
    .web-link-header {
      padding-bottom: 10px;
      margin-bottom: 10px;
      border-bottom: 1px solid var(--download-popup-border);

      .left-container {
        .icon {
          width: 20px;
          height: 20px;
        }

        .value {
          margin-left: 6px;
          font-size: 13px;
          font-weight: 700;
          color: var(--download-popup-title);
        }
      }

      .right-container {
        .icon {
          width: 12px;
          height: 12px;
        }

        .value {
          margin-left: 6px;
          font-size: 11px;
          color: var(--download-popup-value__special);
        }
      }
    }

    .wen-link-content {
      font-size: 8px;
      color: #04be02;
    }

    .web-link-item + .web-link-item {
      margin-top: 5px;
    }
    .web-link-item {
      gap: 4px;

      .label {
        font-size: 11px;
        color: var(--download-popup-value);
      }

      .link {
        font-size: 11px;
        color: var(--download-popup-value__special);
        word-break: break-all;
      }

      .icon {
        margin-left: 5px;
      }
    }

    .web-link-footer {
      display: grid;
      grid-template-columns: repeat(2, calc(50% - 5px));
      grid-gap: 10px;
      margin-top: 10px;

      .buttons {
        width: 100%;
        height: 36px;
        background: #26744a;
        border: 1px solid #26744a;
        border-radius: 7px;
        font-size: 12px;
        color: #ffffff;

        &.link {
          background: transparent;
          color: #26744a;
        }
      }
    }
  }
}
</style>
